import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { map } from 'rxjs';
import { AccessService } from './access.service';
import { NotificationService } from '@foundation/notification';

export interface AdminGuardOptions {
	// When true (default), only verified admins can pass.
	// When false, any admin can pass, even if email is not verified yet.
	requiresEmailVerification?: boolean;
}

export const adminGuard = ({ requiresEmailVerification: requiresEmailVerification = true }: AdminGuardOptions = {}): CanMatchFn => {
	return (route: Route, segments: UrlSegment[]) => {
		const accessService = inject(AccessService);
		const notificationService = inject(NotificationService);
		return accessService.checkAdminStatus$().pipe(
			map(({ isAdmin, isVerified }) => {
				// Non-admin users are always rejected.
				if (!isAdmin) return false;
				// Dashboard use-case: allow admins even if unverified.
				if (!requiresEmailVerification) return true;
				// if not isVerified : notify the user
				if (!isVerified) {
					notificationService.error('Your email address must be verified');
				}
				// Default behavior: admin + verified email required.
				return isVerified;
			})
		);
	};
};

// Convenience aliases:
// - adminAndVerifiedGuard: strict mode (default)
// - adminOnlyGuard: relaxed mode (no email verification required)
export const adminAndVerifiedGuard: CanMatchFn = adminGuard();
export const adminOnlyGuard: CanMatchFn = adminGuard({ requiresEmailVerification: false });
